import { AgingRecord } from './AgingRecord';
import { SidebarStatus } from './SidebarStatus';
import { BackgroundStatus } from './BackgroundStatus';
import { NoStyling } from './NoStyling';
import { BackgroundFeatureType } from './BackgroundFeatureType';

const CardStylings = {
  AgingRecord,
  SidebarStatus,
  BackgroundStatus,
  BackgroundFeatureType,
  NoStyling,
};

export default CardStylings;
